jQuery.noConflict();
(function ($) {
    const smallcontactform = $("#Form_SmallContactform");
    const submitbtn = smallcontactform.find('input[type=submit]');
    const emailfield = smallcontactform.find('input[name=Email]');
    const phonefield = smallcontactform.find('input[name=Phone]');

    smallcontactform.validate({
        /*submitHandler: function(form){
          alert('valid');
          return false;
        },*/
        submitHandler: function (form) {
            var url = $(form).attr('action');
            var data = $(form).serialize();
            var success = function (data) {
                let t = $('#validationError');
                t.html('');
                for (const item of data) {
                    t.append('<p class="' + item.messageType + '">' + item.message + '</p>');
                    if (item.success) {
                        $(form).parent().html('<p class="' + item.messageType + '">' + item.message + '</p>');
                    }
                    t.show(50);
                }
            }
            $.post(url, data, success, 'json');
            return false;
        },
        highlight: function (element, errorClass) {
            $(element).closest('.field').addClass(errorClass);
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).closest('.field').removeClass(errorClass);
        },
        focusInvalid: false,
        errorLabelContainer: "#errorLabels",
        errorElement: "span",
        showErrors: function (errorMap, errorList) {
            if (errorList.length) {
                $("#validationError").html("<div class='bg-danger text-white mb-3 p-3'>Bitte bearbeiten Sie die markierten Felder.</div>").show(50);
            } else {
                $("#validationError").hide(50);
            }
            this.defaultShowErrors();
        },
        rules: {
            "Name": {
                required: true
            },
            "Phone": {
                required: true
            },
            "Email": {
                email: true
            },
            "Disclaimer": {
                required: true
            },
            "Message": {
                required: true
            }
        }
    });
}(jQuery));
